import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EcddReducer } from '../reducers';

export const selectEcddFeature = createFeatureSelector<EcddReducer.EcddState>(EcddReducer.featureName);

export const selectItemDetail = createSelector(selectEcddFeature, ({ item }) => item);

